import {
  // filterCategoryView,
  // filterPostView,
  resourcesView
} from "../modules/barba/barba-helpers";
import {
  gsap
} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import {
  activateRelated,
  objectOrientation,
  applyGradientLine
} from "./helpers";
import init, { initLottie } from "../../../includes/lottie/lottie";
import { onEnterBackFunction, onEnterFunction, onLeaveBackFunction, onLeaveFunction } from './helpers';
import { stickyStyled } from "./stickystyled";


export function singleUi(container) {
  console.log('singleUi', container);

  gsap.registerPlugin(ScrollTrigger); // (or in the top-level file in your React app)

  // let resources = container.querySelector('.article__content'); // was using this but better naming conventoin:
  let articleContent = container.querySelector('.article__content'),
    relatedContent = articleContent.querySelector('.single__related'),

    // type of content - used to determine filter type
    type = "single", //aka initiator -aka Related Posts Resourcds
    // containerYype - used to determined function options based on Dom container
    containerType = "pre-transform", // dentoing that this runs after the barba change ; data.next.container
    postTransformContent = container.querySelector('.--post-transform'),
 
    activePost = document.querySelector('body').getAttribute('data-active-post'), // This would the be the post that was clicked on -i.e this post
    activeCategory = document.querySelector('body').getAttribute('data-active-category'), // this would be the category that was clicked on - i.e this category
  
    // gsap timeline
    tlSingle = new gsap.timeline(),
    tlSinglePause = true, // this will allow me to pause the timeline when needed
    tlRelated = new gsap.timeline(),
    markersVal = true; // on the timeline (see below)


  //end vars


  // console.log("body", body);
  // console.log("activePost - singleUi", activePost);
  // console.log("activeCategory - in Ui", activeCategory);

  // Resources UI (using articleContent)
  if (relatedContent.toString().length > 0) {

    //revewiw and impletmenet accoridngly:
    //  // resourceCategoriesUl panel orientation - review - the need to have this run on the barbar pre-transform as well...
  //  var resourceCategoriesUl = relatedContent.querySelector('.archive__body[data-resource-content="archive"] ul');
   var resourceCategoriesUl = relatedContent.querySelector('.panel__body[data-resource-content="archive"] ul'); // not sure about uysing this naming convent "panel" but reviewing in consuyution with tempalte work
   var relatedContentHeader = relatedContent.querySelector('.panel__header-title');

      // inititalise lottie animations
      // initLottie(container);
      initLottie(relatedContent);



  //  console.log("activePost - singleUi", activePost);
    // can we leave this oreientaon change i - because don't think it would affect transitons?
    ///review if this does caus gsap issues
    //disavle this - keep constintaly horiztonal
    //  objectOrientation(resourceCategoriesUl);
 
    // console.log("relatedContent resources exists in Single", relatedContent);
      resourcesView(relatedContent, type); // this is the new content to intialise views
    // console.log("END relatedContent resources view in Single");

    // we want to make some changes to the relalted content when it reaches the top
    // stickyStyled(relatedContent);// try with class - but if I want to change the dome - review apprach (use scroll trigger or something)
    activateRelated(relatedContent)
    // should have altered the view to match the post transform content!? review this...
     // we know the post transform js is triggered via the barba tranistion.
    //the new content js shoudl be fired after the barba transition is complete (i.e here)

    // I need trigger the lcick here mayvbe?
// set up a scroll trigger so that when the user reaches the top of the related content - a class is aplied
// and the related content is fixed to the top of the page
// then when the user scrolls back up - the class is removed and the related content is fixed back to its original position
// this will be a nice touch to the user experience
// and also a nice touch to the design

 

  }
 
  // Post Transform UI Transitions - ensure the above is fully finished before running this - review approach with gsap timelinbe
  if (postTransformContent.toString().length > 0) {
  //  console.log("postTransformContent exists in Single", postTransformContent);
    // temp disablethis
    tlSingle.fromTo(postTransformContent, {
        opacity: 1,
      }, {
        // opacity: 1, // temp disable - I need to figure out what further needs doing before its a seamless transition from the post transofrm ot the page content - i.e other things not happening yet?!?
        opacity: 0, // re-enabled 18th arpil 2024

        // PointerEvents: "none",
      }, "0") // review this timing
      .fromTo(articleContent, {
        opacity: 0,
        zIndex: 20,
      }, {
        opacity: 1,
        zIndex: 2,
      }, "<") // review this timing

    // postTransformContent.style.pointerEvents = "none";
    // temp meauser - look to apply post loading class or someting
    // and/or z index as well.

    // console.log("Gsap Transition on Single ccontent containers Ended");


    //after we've finsihed the transforming - maybe I should ensure to celar out all the data attrributes: - Review acrsoss all post barbab instaces
    // document.querySelector('.body').removeAttribute('data-active-post');
    // document.querySelector('.body').removeAttribute('data-active-category');
    // or leave it because they are "active" references to the state of the content - so needs to just be what's there at all times....!?

    ///Gradient line

    /* make sure to revist the whole idea in more deatil befor ei start bodging away
        applyGradientLine(gradientLine, linkTarget);

    */

    let gradientLineContainer = document.querySelector('.line-container');
    let gradientLine = gradientLineContainer.querySelector('.line');

    //  let linkTarget = event.target.getAttribute('data-'),
    let linkTarget = "resources"; // review necisity


    applyGradientLine(gradientLine, linkTarget);
    //  deActivateGradientLine(gradientLine)
    ///END Gradient line  
  }


}

